import { CnRangeTimePicker2, componentMap as formComponentMap, } from '@cainiaofe/cn-ui';
import { DisplayPosition } from '@/common/manager/position/display-position';
export const config = {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.filter,
        DisplayPosition.cnArrayTable,
        DisplayPosition.cnArraySubAreaCard,
    ],
    componentName: 'RangeTimePicker',
    component: CnRangeTimePicker2,
    formComponent: formComponentMap.CnRangeTimePicker2,
};
